import React from "react";
import { Box, Grid, Paper, Typography, Stack, Button } from "@mui/material";

const ReservationTimeline = ({ reservations,  onCancelClicked=undefined }) => {
  reservations.sort((a, b) => {
    const dateA = new Date(a.StartTime);
    const dateB = new Date(b.StartTime);
    return dateA - dateB;
  });
  const currentTime = new Date();
  const hoursBeforeAfter = 240; // 12 hours before and after

  const parseDate = (dateString) => new Date(dateString);

  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);
    return date.toLocaleString("zh-TW", { timeZone: "Asia/Taipei" });
  };

  const isWithinTimeHorizon = (startTime, endTime) => {
    const startLimit = new Date(
      currentTime.getTime() - hoursBeforeAfter * 60 * 60 * 1000
    );
    const endLimit = new Date(
      currentTime.getTime() + hoursBeforeAfter * 60 * 60 * 1000
    );
    let parsedStartTime = parseDate(startTime);
    let parsedEndTime = parseDate(endTime);
    return (
      (parsedStartTime >= startLimit && parsedStartTime <= endLimit) ||
      (parsedEndTime >= startLimit && parsedEndTime <= endLimit)
    );
  };

  const hasReservations = reservations && reservations.length > 0;

  return (
    <Box>
      {hasReservations ? (
        <Typography variant="h6">訂位時間</Typography>
      ) : (
        <Typography variant="h6">目前無訂位</Typography>
      )}
      <Grid container>
        {hasReservations &&
          reservations
            .filter(({ StartTime, EndTime }) =>
              isWithinTimeHorizon(StartTime, EndTime)
            )
            .map((reservation, index) => (
              <Grid item xs={12} key={index}>
                <Paper elevation={3} style={{ margin: "8px", padding: "16px" }}>
                  <Stack
                    direction={"row"}
                    display={"flex"}
                    justifyContent={"space-between"}
                  >
                    <Stack direction={"column"}>
                      <Typography variant="body1">
                        訂單編號:{" "}
                        {reservation.OrderId === "mod"
                          ? "後臺設定"
                          : reservation.OrderId}
                      </Typography>
                      <Typography variant="body1">
                        名稱:{" "}
                        {reservation.OrderId === "mod" ? "" : reservation.Name}
                      </Typography>
                      <Typography variant="body1">
                        電話:{" "}
                        {reservation.OrderId === "mod" ? "" : reservation.Phone}
                      </Typography>
                      <Typography variant="body1">
                        開始: {formatDateTime(reservation.StartTime)}
                      </Typography>
                      <Typography variant="body1">
                        結束: {formatDateTime(reservation.EndTime)}
                      </Typography>
                    </Stack>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        onCancelClicked( reservation.StartTime);
                      }}
                    >
                      取消預約
                    </Button>
                  </Stack>
                </Paper>
              </Grid>
            ))}
      </Grid>
    </Box>
  );
};
export default ReservationTimeline;
